// extracted by mini-css-extract-plugin
module.exports = {"card":"HubCardSkeleton_card__nrnUN"};